import { Card, Typography } from 'antd'
import { memo } from 'react'
import styled from 'styled-components'

import PersonalInformationForm from './PersonalInformationForm'
import { TPersonalInformationForm } from 'src/pages/teacher-request-detail/fill-in-teacher-information/types'
import { useTranslation } from 'react-i18next'

export const PersonalInformation = memo((props: TPersonalInformationForm) => {
  const { t } = useTranslation(['teacherRequest'])
  return (
    <PersonalInformationStyled>
      <Typography.Title level={4} className="text-left">
        {t('teacherRequest:personal_information')}
      </Typography.Title>
      <PersonalInformationForm {...props} />
    </PersonalInformationStyled>
  )
})

const PersonalInformationStyled = styled(Card)`
  .ant-card-body {
  }

  .reset-form {
    > div:last-child {
      justify-content: center;
    }
  }
`
